import React, { useContext, useEffect, useState } from 'react';
// AUTH
import { AuthContext } from '../contexts/AuthContext';
// REACT ROUTER
import { useNavigate, useLocation } from 'react-router-dom';
// AXIOS
import axios from 'axios';
// REACT HOOK FORM
import { useForm } from "react-hook-form";
// REACT SELECT
import Select from 'react-select';
// REACT SWEETALERT
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// REACT SPINNER
import { Watch } from 'react-loader-spinner';
// BOOTSTRAP
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// DYNAMIC ICON
import DynamicIcon from '../partials/DynamicIcon';
// ICONS
import { IoIosArrowBack } from 'react-icons/io';
import { BsTrash } from 'react-icons/bs';
import { BiPlus } from 'react-icons/bi';

function CustomersAdd() {
  // AUTH, STATE, NAVIGATION
  const { authobj } = useContext(AuthContext);
  const { state } = useLocation();
  let navigate = useNavigate();
  // FORM
  const { register, handleSubmit, reset } = useForm();
  // SWEETALERT
  const MySwal = withReactContent(Swal);
  // DATA
  const [customer, setCustomer] = useState();
  const [provinces, setProvinces] = useState();
  const [suppliers, setSuppliers] = useState([]);
  const [selectSuppliers, setSelectSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [towns, setTowns] = useState([]);
  const [selectTowns, setSelectTowns] = useState([]);
  const [selectedTown, setSelectedTown] = useState(null);
  // SPINNER
  const [wait, setWait] = useState(false);
  const [waitPercent, setWaitPercent] = useState(null);

  useEffect(() => {
    setWait(true);

    // Carico le province
    axios.post(window.SERVER_URL+'provinces/list', {}, { headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer '+authobj.token
    }}).then(res => {
      setProvinces(res.data);

      // Recupero la lista dei comuni
      axios.post(window.SERVER_URL+'locations/towns', {}, { headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer '+authobj.token
      }}).then(res => {
        setTowns(res.data);
        let select_options = [];
        res.data.map((town) => {
          select_options.push({ value: town.id, label: town.nome });
        });
        setSelectTowns(select_options);

        // Carico i fornitori
        axios.post(window.SERVER_URL+'suppliers/list', {}, { headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'Bearer '+authobj.token
        }}).then(res => {
          setSuppliers(res.data.suppliers);
          let select_options = [];
          res.data.suppliers.map((supp) => {
            select_options.push({ value: supp.id, label: supp.ragione_sociale });
          });
          setSelectSuppliers(select_options);

          // Se sto modificando un cliente esistente, carico le informazioni relative
          if (state && state.customer_id) {
            axios.post(window.SERVER_URL+'customers/get', { id: state.customer_id }, { headers: {
              'Access-Control-Allow-Origin': '*',
              'Authorization': 'Bearer '+authobj.token
            }}).then(res => {
              console.log(res.data);
              setCustomer(res.data);

              // Mi setto le select
              if (res.data.supplier_id)
                setSelectedSupplier({ value: res.data.supplier_id, label: res.data.supplier.ragione_sociale });
              if (res.data.town_id)
                setSelectedTown({ value: res.data.town_id, label: res.data.town.nome });

              // Setto i campi della form
              let fields = {};
              for (const [key, val] of Object.entries(res.data))
                if (typeof val !== 'object' && key != 'etichetta')
                  fields[key] = val;
              reset(fields);
            });

            setWait(false);
          } else {
            setWait(false);
          }
        });
      });
    });
  }, [reset]);
  
  // Submit della form
  const onSubmit = (form_data) => {
    console.log("*** FORM DATA INVIATI ***");
    console.log(form_data);
    form_data.supplier_id = selectedSupplier ? selectedSupplier.value : null;
    form_data.town_id = selectedTown ? selectedTown.value : null;
    axios.post(window.SERVER_URL+'customers/save', form_data, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer '+authobj.token,
        // 'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      // console.log(res.data);
      Swal.fire({
        icon: 'success',
        title: 'Utente registrato',
        text: 'Cosa vuoi fare adesso?',
        // showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Crea nuova ubicazione utente',
        // denyButtonText: 'Nuova pianificazione',
        cancelButtonText: 'Vai alla lista utenti',
        confirmButtonColor: '#198754',
        cancelButtonColor: '#3085d6',
        // denyButtonColor: '#3085d6',
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          navigate('/locations/add', { state: { customer_id: res.data.entity_id } });
        } else {
          navigate('/customers');
        }
      });
    }).catch(function(error) {
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        html: 'Si è verificato un errore durante il salvataggio del cliente: <i>'+error+'</i>'
      });
    });
  }

  return (
    <>
      { wait ? 
        <div id="wait">
          { waitPercent !== null ?
            <div className="percent">{waitPercent}%</div>
          : '' }
          <Watch height="80" width="80" radius="48" color="#44B2EB" ariaLabel="watch-loading" wrapperStyle={{}} wrapperClassName="" visible={true} />
        </div>
      : '' }
      <Container className="content">
        <Row className="page_title">
          <Col>
            <h1>Aggiungi o modifica cliente</h1>
          </Col>
        </Row>
        <Row>
          <Col className="custom_form_wrapper">
            <form className="custom_form" onSubmit={handleSubmit(onSubmit)}>
              <fieldset style={{'background':'#c7e8c8','padding':'5px 20px 20px'}}>
                <label className="fieldset_label"><DynamicIcon iconName="FaUser" size="20" /> INFORMAZIONI ANAGRAFICHE</label>
                <Row>
                  <Col lg={1}>
                    <label>Codice</label>
                    <input type="text" placeholder="Codice" {...register("codice")} />
                  </Col>
                  <Col>
                    <label>Nome</label>
                    <input type="text" placeholder="Nome" {...register("nome")} />
                  </Col>
                  <Col>
                    <label>Cognome</label>
                    <input type="text" placeholder="Cognome" {...register("cognome")} />
                  </Col>
                  <Col>
                    <label>Ragione sociale</label>
                    <input type="text" placeholder="Ragione sociale" {...register("ragione_sociale")} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <label>Partita IVA</label>
                    <input type="text" placeholder="Partita IVA" {...register("partita_iva")} />
                  </Col>
                  <Col>
                    <label>Codice fiscale</label>
                    <input type="text" placeholder="Codice fiscale" {...register("codice_fiscale")} />
                  </Col>
                  <Col>
                    <label style={{'marginTop':'15px'}}>Fornitore</label>
                    <Select value={selectedSupplier} isDisabled={false} isLoading={false} isClearable={true} isRtl={false} isSearchable={true} name="supplier_id" options={selectSuppliers} onChange={(e) => setSelectedSupplier(e)} />
                  </Col>
                </Row>
              </fieldset>
              <fieldset style={{'background':'#f2e9b5','padding':'5px 20px 20px','marginTop':'20px'}}>
                <label className="fieldset_label"><DynamicIcon iconName="FaMapMarkerAlt" size="20" /> INFORMAZIONI GEOGRAFICHE</label>
                <Row>
                  <Col>
                    <label>CAP</label>
                    <input type="text" placeholder="CAP" {...register("cap")} />
                  </Col>
                  <Col lg={10}>
                    <label>Indirizzo</label>
                    <input type="text" placeholder="Indirizzo" {...register("indirizzo")} />
                  </Col>
                  
                </Row>
                <Row>
                  <Col lg={4}>
                    <label style={{'marginTop':'15px'}}>Comune</label>
                    <Select value={selectedTown} isDisabled={false} isLoading={false} isClearable={true} isRtl={false} isSearchable={true} name="town_id" options={selectTowns} onChange={(e) => setSelectedTown(e)} /> 
                  </Col>
                  <Col>
                    <label>Provincia</label>
                    <select {...register("province_id")}>
                      <option value="">- Scegli una provincia -</option>
                      { provinces ? provinces.map((prov) => {
                        return <option key={ prov.id } value={ prov.id }>{ prov.descrizione }</option>
                      }) : '' }
                    </select>
                  </Col>
                  <Col>
                    <label>Nazione</label>
                    <input type="text" placeholder="Nazione" {...register("stato")} />
                  </Col>
                </Row>
              </fieldset>
              <fieldset style={{'background':'#ecdaf2','padding':'5px 20px 20px','marginTop':'20px'}}>
                <label className="fieldset_label"><DynamicIcon iconName="BsTelephoneFill" size="20" /> INFORMAZIONI DI CONTATTO</label>
                <Row>
                  <Col>
                    <label>Telefono</label>
                    <input type="text" placeholder="Telefono" {...register("telefono")} />
                  </Col>
                  <Col>
                    <label>Cellulare</label>
                    <input type="text" placeholder="Cellulare" {...register("cellulare")} />
                  </Col>
                  <Col>
                    <label>Indirizzo e-mail</label>
                    <input type="text" placeholder="Indirizzo e-mail" {...register("email")} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <label>Indirizzo PEC</label>
                    <input type="text" placeholder="Indirizzo PEC" {...register("pec")} />
                  </Col>
                  <Col>
                    <label>Codice destinatario</label>
                    <input type="text" placeholder="Codice destinatario" {...register("sdi")} />
                  </Col>
                </Row>
              </fieldset>
              <Button type="submit" variant="primary" className="waste_btn">Salva</Button>
            </form>
          </Col>
        </Row>
        <Row className="action_bar bottom">
          <Col>
            <Button onClick={() => navigate('/customers', { state: { page: (state && state.page ? state.page : 1), query: (state && state.query ? state.query : null) } })}><IoIosArrowBack /> Torna indietro</Button>
          </Col>
        </Row>
      </Container>
    </>
  );

  
}

export default CustomersAdd;